function GlobalFormError({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex h-full items-center justify-center p-4">
      <em className="text-red-500 text-base font-normal">{children}</em>
    </div>
  );
}

export default GlobalFormError;
